import * as PIXI from "pixi.js";
import {drawRoundedRect} from "../../utils/graphics";
import {Assets} from "pixi.js";
import {bgSound, events} from "../../utils/pixiApp";

const textStyle = new PIXI.TextStyle({
    fontSize: 16,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 700,
    fill: 'rgba(11, 11, 11, 0.87)',
    letterSpacing: 0.15,
    lineHeight: 22.4
})

const buttons = {
    yes: {
        default: 'buttonYesDefault',
        hover: 'buttonYesHover'
    },
    no: {
        default: 'buttonNoDefault',
        hover: 'buttonNoHover'
    }
}

export class SoundModalComponent extends PIXI.Container {
    constructor() {
        super();

        this.width = 242
        this.height = 112
        this.bg = new PIXI.Graphics()
        this.setSize(this.width, this.height)
        drawRoundedRect(this.bg, -121, -56, 242, 112, 20);
        this.bg.fill('#FFFFFF')

        this.text = new PIXI.Text({ text: 'ВКЛЮЧИТЬ ЗВУК?', style: textStyle });
        this.text.position.set(this.bg.x, -10)
        this.text.anchor.set(.5,.5)

        this.bg.addChild(this.text)
        this.buttonGroup = new PIXI.Graphics().rect(0,0,200, 40);

        this.buttonGroup.position.set(-100, 34)
        this.pivot.set(.5,.5)

        this.yesBtn = new PIXI.Sprite(Assets.get(buttons.yes.default));
        this.yesBtn.setSize(100, 40)
        this.buttonGroup.addChild(this.yesBtn)
        this.noBtn = new PIXI.Sprite(Assets.get(buttons.no.default));
        this.noBtn.setSize(100, 40)
        this.noBtn.position.set(100, 0)

        this.buttonGroup.addChild(this.noBtn, this.yesBtn)
        this.bg.addChild(this.buttonGroup)

        this.addChild(this.bg)

        this.yesBtn.eventMode = 'static';
        this.noBtn.eventMode = 'static';
        this.yesBtn.cursor = 'pointer'
        this.noBtn.cursor = 'pointer'

        this.yesBtn.on("pointerover", (e) => {this.onHover(e,'yes')});
        this.yesBtn.on("pointerout", this.onLeave.bind(this));
        this.noBtn.on("pointerover", (e) => {this.onHover(e,'no')});
        this.noBtn.on("pointerout", this.onLeave.bind(this));
        this.yesBtn.on('pointerdown', (e) => {this.onClick(e,'yes')})
        this.noBtn.on('pointerdown', (e) => {this.onClick(e,'no')})
    }

    onHover(_, type) {
        this[type === 'yes' ? 'yesBtn' : 'noBtn'].texture = Assets.get(buttons[type].hover);
    }

    onLeave() {
        this.yesBtn.texture = Assets.get(buttons.yes.default);
        this.noBtn.texture = Assets.get(buttons.no.default);
    }

    onClick(_, type) {
        if(type === 'yes') {
            bgSound.play()
        } else {
            bgSound.stop()
        }
        events.emitSoundEvent(type === 'yes')
        this.emit('IS_OPEN_EVENT', false)
    }

}